import { css } from 'styled-components';

export const inlineStyle = (props) => css`
  display: ${props.inline ? 'inline-block' : 'block'};
`;

export const marginStyle = (props) => css`
  margin-top: 0;
  margin-bottom: ${props.noMargin ? 0 : '10px'};
`;

export const colorStyle = (defaultColor) => (props) => css`
  color: ${props.theme.colors[defaultColor || props.color || 'secondary']};
  ${props.backgroundColor ? `background-color: ${props.theme.colors[props.backgroundColor]};` : ''}
`;

export const cursorStyle = (props) => css`
  ${props.withCursor ? `cursor: pointer;` : ''}
`;

export const fontStyle = (TYPO_STYLES) => (props) => css`
  font-family: ${props.theme.fonts[TYPO_STYLES.font]};
  font-weight: ${props.bold ? 'bold' : props.light ? 300 : 'normal'};
  font-size: ${TYPO_STYLES[props.type].size}px;
  line-height: ${TYPO_STYLES[props.type].lh}px;
  letter-spacing: ${TYPO_STYLES[props.type].ls ? `${TYPO_STYLES[props.type].ls}px` : 'unset'};
  ${props.upperCase ? `text-transform: uppercase;` : ''}
  ${props.lowerCase ? `text-transform: lowercase;` : ''}
  ${props.textCenter ? `text-align: center;` : ''}
`;

export const baseStyles = () => css`
  ${inlineStyle}
  ${marginStyle}
  ${cursorStyle}
  ${colorStyle()}
`;
